import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
login:{
buttoo:{
    add:'add'
}
},
dialog:{
buttton:{
    close:'Close',
},
ReportError:{
      next:'Next',
 h1:'Report Errors allows users to communicate with us to solve any data issues and improve data quality.',
 li1:'If you find any data problems or have a question about this data',
 li2:'If you want to contribute company information to improve this data',
 li3:'If you choose not to disclose your own company information that you might consider private',
 li4:'If you have any constructive suggestions for us to improve services',
 h2:"All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company."
},
},
Home:{
  Applications:'Applications',
  SearchCompanies:'Search Companies',
  SearchTrade:'Search Trade',
  SearchRisks:'Search Risks',
  SearchCountries:'Search Countries',
  SearchNews:'Search News',
  SearchLeads:'Search Leads',
 selectCountry:'Select Country', //选择公司
 inputCompany:'Enter company name', //输入公司名称
 searchCompanyNum:"Search 500+ million companies in 200+ countries and territories",
 keWord:'Keyword',//关键词
 firstWord:"left partial",//首词
 search:'Search',//搜索
 homeSeachTitle:'Bringing Global Business Into Focus',//聚焦全球商情
 homeTitleDetail:'CSI, a data-driven research and IT firm, specializes in credit, risk, and big data. It offers digital tools to global investors and business professionals, leveraging advanced analytics and algorithms to provide fast, visual insights that facilitate smarter decision-making. ',
 phoneTitleDetail:'To quickly search, view, and obtain company information, you can also use the CSI App on your phone. ', //您可以使用手机上的 CSI App 快速搜索、查看和获取公司信息。,
 IndustryAnalysis :'Industry Analysis',
BusinessAnalytics :'Business Analytics',
ImportExportData :'Import-Export Data',
CompanyNews :'Company News',
Sanctions :'Sanctions',
SearchLeads:"Search Leads",
BusinessIntelligence :'Business Intelligence',
CompanyIdentityVerification :'Company Identity Verification',
KYCSolutions :'KYC Solutions',
OwnershipPenetration :'Ownership Penetration',
CompanyFinancialAnalysis:'Company Financial Analysis',
CreditRatings :'Credit Ratings',
CreditReports :'Credit Reports',
ESGRatings :'ESG Ratings',
VendorScreening :'Vendor Screening ',
MarketResearch:'Market Research ' 

},
IndustryStatistics:{
    SubjectCompany:"Subject Company",
    Country:"Country",
    Compare:"Compare",
    Industry:"Industry",
    CompanyType:"Company Type",
    CompanySize:"Company Size",
    CompanyStatus:"Company Status",
    YearsinBusiness:"Years in Business",
    CompanyRating:"Company Rating"
},
ListofResults:{
  SelectCountry:'Select Country',
  ClearAll:'Clear All',
  SelectIndustry:'Select Industry',
  ListedCompany:'Listed Company',
  YearsinBusiness:'Years in Business',
   Sharethisinformation:'Share this information',
  Pleaseaddress:'Please enter one or more email address :',
  Example:'Example',
  message:'Message',
  pleaseleaveamessage:'Please leave a message',
  Include:'Include',
  thisaddress:'This company name , ID , address',
  CSIwebsite:'CSI website',
  Update:'Update',
  Iftheavailable:'If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.',
  Abusinesscredit :'A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.',
  Searchcompanies:'Search more emails on other companies',
  Rowsperpage:'Rows per page',
     CountyCity:'County/City'

},
Toolbar:{
    Filter:"Filter",
    Select:"Select",
    Edit:"Edit",
    Sortby:"Sort by",
    Collect:"Collect",
    Saved:"Saved",
    Compare:"Compare",
    Export:"Export",
    Download:"Download",
    Update:"Update",
    Reporterror:"Report error",
    Share:"Share",
    ascending:'ascending',
    descending:'descending',
    Customfolder:'Custom folder'
},
AiZaba:{
whatareyousearchingfor:'what are you searching for',
CreditAnalyst:'Credit Analyst',
Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
LegalAdvisor:"Legal Advisor",
Provides:'Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.',
BizConsultant:'Biz Consultant',
Optimizes:'Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency',
EconomicAnalyst:'Economic Analyst',
Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive."
},
ContentTabs:{
    Background:"Background",
    BusinessActivities:"Business Activities",
    Performance:"Performance",
    Publications:"Publications",
    CreditOpinion:"Credit Opinion",
    MarketAnalysis:"Market Analysis",
    Snapshot:"Snapshot",
    Profile:"Profile",
    Ownership:"Ownership",
    RelatedCompanies:"Related Companies",
    Management:"Management",
    Operations:"Operations",
    Locations:"Locations",
    Industry:"Industry",
    ImportExport:"Import & Export",
    SupplyChain:"Supply Chain",
    FinancialHighlights:"Financial Highlights",
    RatioAnalysis:"Ratio Analysis",
    IndustryNorm:"Industry Norm",
    News:"News",
    Sanctions:"Sanctions",
    IndustryStatistics:"Industry Statistics",
    RatingAnalysis:"Rating Analysis",
    CompetitiveAnalysis:"Competitive Analysis",
    Lawsuits:"Lawsuits"
},
navigationBar:{
Notifications:'Notifications',//通知
MarkasRead:'Mark as Read',//标记已读
Viewall:'View all',//查看全部
SilverSubscriber:'Silver Subscriber',//银级用户
Silversubscriberdate:'Silver subscription expiration date',//银级到期日
GoldSubscriber:'Gold Subscriber',//金级用户
Goldsubscriptiondate:'Gold subscription expiration date',//金级到期日
AvailableCredits:'Available Credits',//可用积分
AddCredits:'Add Credits',//购买积分
IndivdualAccount:'Indivdual Account', //个人账号
GroupAccount:'Group Account' //集团账号

},

Snapshot:{
    CompanyDQIdesc:"The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
  CountryDQIdesc:"The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices. Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
  CompanyDQI:'Company DQI',//公司数据质量指数 DQI
  CountryDQI:'Country DQI',//国家数据质量指数 DQI
  Address:'Address',//地址
  CountyCity:'County/City',//县/市
  ProvinceState:'Province/State',//省/州
  CountryRegion:'Country/Region',//国家/地区
  ZipCode:'Zip Code',//邮政编码
  Website:'Website',//网站
  Email:'Email',//电邮
  Tel:'Tel',//电话
  LastUpdate:'Last Update',//最近更新
  DataSource:'Data Source',//数据来源
  LegalStatus:'Legal Status',//法定状况
  CoID:'Co. ID',//公司ID
  CompanyType:'Company Type',//公司类型
  RegistrationDate:'Registration Date',//注册日期
  RegistrationStatus:'Registration Status',//注册状态
  Listed:'Listed',//上市信息
  CurrentOpperations:'Current Operations',//经营状况
  IndustryCode:'Industry Code',//行业代码
  BusinessActivities:'Business Activities',//主营业务
  NoofEmployees:'No. of Employees',//员工数量
  NoofShareholders:'No. of Shareholders',//股东数量
  Management:'Management',//管理状况
  Performance:'Performance',//业绩表现
  Revenue:'Revenue',//收入
  Assets:'Assets',//资产
  ProfitLoss:'Profit/Loss',//利润
  Growth:'Growth',//公司增长
  Competitiveness:'Competitiveness',//竞争力
  CreditOpinion:'Credit Opinion',//信用状况
  CreditRating:'Credit Rating',//信用评级
  CreditScore:'Credit Score',//信用评分
  ESGRating:'ESG Rating',//ESG 评级
  Solvency:'Solvency',//偿还能力
  Sanctions:'Sanctions',//全球制裁
},
Profile:{
  CompanyProfile:'Company Profile',//基本资料
  CompanyName:'Company Name',//公司名称
  NativeName:'Native Name',//当地名称
  CompanyID:'Company ID',//公司 ID
  VATNumber:'VAT Number',//VAT号
  StockCode:'Stock Code',//股票代码
  Listed:'Listed',//上市日期
  RegistrationDate:'Registration Date',//注册日期
  LegalForm:'Legal Form',//公司性质
  CompanyType:'Company Type',//公司类型
  LegalStatus:'Legal Status',//注册状态
  Jurisdiction:'Jurisdiction',//司法管辖区
  RegisteredAddress:'Registered Address',//注册地址
  ProvinceState:'Province/State',//省/州
  CountryRegion:'Country/Region',//国家/地区
  ZipCode:'Zip Code',//邮政编码
  OperatingAddress:'Operating Address',//经营地址
  LastUpdate:'Last Update',//最近更新
  DataSource:'Data Source',//数据来源
  History:'History',//历史记录
  RegisteredCapital:'Registered Capital',
  PaidinCapital:'Paid-in Capital',
       CountyCity:'County/City'
},
Ownership:{
 UltimateBeneficiary:'Ultimate Beneficiary Owner',//最终受益人
  InvolvingIndividuals:'Involving Individuals',//涉及自然人股东
  InvolvingEnterprises:'Involving Enterprises',//涉及法人股东
  ShareholderLevel:'Shareholder Level',//股东层级x
  Name:'Name',//名称
  Country:'Country',//国家/地区
  Location:'Location',//地点
  Type:'Type',//类型
  Shares:'Shares',//股份
  Relation:'Relation',//关系
    Individuals :'Individuals',//关系
        PartiesInvolved:'Parties Involved',
  RelatedCompany:'Related Company',
  CompanyShareholders:'Company Shareholders',
  NGOShareholders:'NGO Shareholders',
  NaturalPersonShareholder:'Natural Person Shareholder',
  SubjectInvestments:"Subject's Investments"
},
RelatedCompanies:{
 Total:'Total',//相关公司总计
  Entities:'Entities',//法人实体
  Countries:'Countries',//国家/地区
  Branches:'Branches',//分支机构
  RelatedComp:'Related Companies',//关联公司
  Name:'Name',//名称
  Country:'Country',//国家/地区
  Location:'Location',//地点
  Type:'Type',//类型
  Relation:'Relationship',//关系
  BranchOffices:'Branch Offices',
  Individuals:'Individuals',
},
Management:{
  Total:'Management',//管理层
  ContactInfo:'Contact Info',//联系人信息
  Countries:'Countries',//国家/地区

  Name:'Name',//名称
  Position:'Position',//职位
  Department:'Department',//部门
  Country:'Country',//国家/地区
  ShareholderNot:'Shareholder or Not',//是否股东
  Relation:'Relations',//关系
  Verification:'Verification',//已验证
  Searchmoreemails:'Search more emails',//搜索更多电邮
  Roles:'Roles',//角色
  EducationLevel:'Education Level',//教育程度
  Phone:'Phone',//电话
  Email:'Email',//电邮
  Verified:'Verified',//已验证
  Searchmore:'Search more emails on other companies',//搜索更多其他公司的电邮
},
Operations:{
  Operations:'Operations',
  LineofBusiness:'Line of Business',//业务范围
  BusinessTerritories:'Business Territories',//业务区域
  ImportExport:'Import & Export',//进出口信息
  Viewtradeinfo:'View more trade info',//查看更多贸易信息
  ProductsServices:'Products/Services',//产品/服务
  Products:'Products',//产品
  ProductImage:'Product Image',//产品图片
  ProductName:'Product Name',//产品名称
  ProductDescription:'Product Description',//产品描述
  Details:'Details',//详情
  Addproductinformation :'Add product information ',//添加产品信息
},
Locations:{
   Locations:"Locations",
  CoName:'Co. Name',//业务范围
  Relationship:'Relationship',//关系
  Country:'Country',//国家/地区
  Location:'Location',//地点
  Address:'Address',//地址
  Edit:'Edit',//编辑
  CompanyLocatiionsMap:'Company Locations in Map',//地图中的公司位置
  Selectaddresstype:'Select address type',//选择地址类型
  Subjectcompany:'Subject company',//目标公司
  Subsidiary:'Subsidiary',//子公司
  RegisteredAddress :'Registered Address',//注册地址
  OperationAddress :'Operation Address',//运营地址
  All :'All',//全部
},
Industry:{
  IndustryTitle:'Industry Title',//IndustryTitle
  IndustryDescription:'Industry Description',//IndustryDescription
  ISIC:'ISIC',//ISIC
  ISICDescription:'ISIC Description',//ISICDescription
  NACE:'NACE',//NACEDescription
  NACEDescription:'NACE Description',//NACEDescription
  NAICS:'NAICS',//NAICS
  NAICSDescription:'NAICS Description',//NAICSDescription
  CSIC:'CSIC',//CSIC, 
  CSICDescription:'CSIC Description',//CSICDescription
  AAAIC:'AAAIC',//AAAIC
  AAAICDescription :'AAAIC Description',//AAAICDescription
  GICS :'GICS',//GICS
  GICSDescriptio :'GICS Descriptio',//GICS 描述
},
ImportExport:{
  TotalImportAmount:'Total Import Amount',//进口总额
  TopImportCountry:'Top Import Country',//最大进口国家/地区
  TopImportProduct:'Top Import Product',//最大进口产品
  TotalExport:'Total Export',//出口总额
  TopExportCountry:'Top Export Country',//最大出口国家/地区
  TopExportProduct:'Top Export Product',//最大出口产品
  TradeVolume:'Trade Volume',//贸易额
  ImportShipments:'Import Shipments',//进口量
  ExportShipments:'Export Shipments',//出口量
  ImportCountries:'Import Countries',//进口国家/地区
  ExportCountries:'Export Countries',//出口国家/地区
  ImportVolume:'Import Volume',//进口量
  ExportVolume:'Export Volume',//出口量
  TopSuppliers:'Top Suppliers',//主要供应商
  ByNumberofShipments:'By Number of Shipments',//按出货量
  TopBuyers:'Top Buyers',//主要买家
  ByNumberofShipments:'By Number of Shipments',//按出货量
  ImportQuantity:'Import Quantity',//进口数量
  IncreaseDecreasexRate:'Increase/Decrease Rate',//增/减率
  ExportQuantity:'Export Quantity',//出口数量
  ImportsExportsRecords:'Imports & Exports Records',//进出口记录
  Date:'Date',//日期
  Product:'Product',//产品
  HSCode:'HS Code',//HS 编码
  BuyerName:'Buyer Name',//买家名称
  Destination:'Destination',//目的地
  SupplierName:'Supplier Name',//供应商名称
  Origin:'Origin',//原产地
  Amount:'Amount',//金额
  Details:'Details',//详情
},
 FinancialHighlight:{
  ProfitabilityRatios:'Profitability Ratios',
  OperatingRatios:'Operating Ratios',
  StructuralRatios:'Structural Ratios',
ProductivityRatios:'Productivity Ratios',
GrowthRatios:'Growth Ratios',
  Revenue:'Revenue',//收入
  Profit:'Profit',//利润
  Growth:'Growth',//增长
  Liquidity:'Liquidity',//现金流状况
  FinancialStructure:'Financial Structure',//融资结构
  CreditOpinion:'Credit Opinion',//信用评估
  RiskIndicator :'Risk Indicator ',//风险指标
  Solvencyindex:'Solvency index',//偿还指数
  Year:'Year',//年份
  Change:'Change',//变化
  FinancialHighlights:'Financial data from the related companies',//关联公司财务数据
  FinancialHighlightsTitle:'Financial Highlights from the Related Companies',//关联公司财务摘要
  CompanyName:'Company Name',//公司名称
  CompanyID:'Company ID',//公司ID
  Country:'Country',//国家/地区
  CompanyStatus:'Company Status',//公司状态
  Relations:'Relations',//关系
  RatioAnalysis:'Ratio Analysis from the Related Companies' //关联公司比率分析

},
IndustryNorms:{
   IndustryStatistics:"Industry Statistics",
    ofcompaniesintheIndustry:"No. of companies in the Industry",
    oflistedCompaniesintheIndustry:"No. of listed Companies in the Industry",
    oflargecompaniesintheIndustry:"No. of large companies in the Industry",
    ofSMEsintheIndustry:"No. of SMEs in the Industry",
    ofcompaniesinsample:"No. of companies in sample",
    ofcompaniesinloss:"No. of companies in loss",
    Observations:"Observations",
    AverageValue:"Average Value",
    MedianValue:"Median Value",
    MaximumValue10:"Maximum Value 10%",
    MinimumValue10:"Minimum Value 10%",
    SubjectCompany:"Subject Company",
    YearsinBusiness:"Years in Business",
    TotalAssets:"Total Assets",
    TotalEquity:"Total Equity",
    Revenue:"Revenue",
    NetEarning:"Net Earning",
    Returnonassets:"Return on assets",
    Performance:"Performance",
    ProfitabilityRatios:"Profitability Ratios",
    Returnonequity:"Return on equity",
    Returnonassets:"Return on assets",
    Grossmargin:"Gross margin",
    OperatingRatios:"Operating Ratios",
    Stockturnover:"Stock turnover",
    Accountsreceivableturnover:"Accounts receivable turnover",
    Assetsturnover:"Assets turnover",
    Totalassetturnover:"Total asset turnover",
    StructuralRatios:"Structural Ratios",
    Currentratio:"Current ratio",
    Quickratio:"Quick ratio",
    Shareholdersliquidityratio:"Shareholders liquidity ratio",
    GrowthRatios:"Growth Ratios",
    Salesgrowthrate:"Sales growth rate",
    Netprofitgrowthrate:"Net profit growth rate",
    Totalassetsgrowthrate:"Total assets growth rate"
},
 News:{
  Date:'Date',//日期
  Title:'Title',//标题
  Source:'Source',//来源
  Impact:'Impact',//影响
  Searchcompanies:'Search more news on other companies',//国家/地区
},
 Sanctions:{
  Potentialcompliance:'Potential compliance risks is detected',//检测到潜在合规风险
  SeachbuttonNo:'Nothing detrimental is detected about this company',//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:'To search for more sanction records, please clickon the"Search Sanctions" button.',//要搜索更多制裁记录，请点击“搜索制裁”按钮。
  SearchSanctions:'Search Sanctions',//搜索制裁
  ViewDetails:'View Details',//查看详情
  Sanctions:'Sanctions',//制裁
  Potentialcompliancerisks:'Potential compliance risks',//潜在合规风险
  IDInfo:'ID Info',//ID 信息
  IDType:'ID Type',//ID 类型
  IDDescription:'ID Description',//ID 描述
  SanctionList:'Sanction List',//制裁名单
  SanctionListInvolved:'Sanction List Involved',//涉及的制裁名单
  StartDate:'Start Date',//生效日期
  EndDate:'End Date',//结束日期
  SourceList:'Source List',//来源名单
  SourceName:'Source Name',//来源名称
  ProfileNotes:'Profile Notes',//主体资料
  Link:'Link',//链接
},
CreditOpinion:{
    CreditAssessment:"Credit Assessment",
    CreditAssessmentfromtheRelatedCompanies:"Credit Assessment from the Related Companies",
    Year:"Year",
    CreditRating:"Credit Rating",
    LocalCreditScore:"Local Credit Score",
    ProbabilityofDefault:"Probability of Default",
    SolvencyIndex:"Solvency Index",
    CreditLine:"Credit Line",
    RiskIndicator:"Risk Indicator",
    RelatedCreditAssessment:"Related Credit Assessment",
    CompanyName:"Company Name",
    CompanyID:"Company ID",
    Country:"Country",
    CompanyStatus:"Company Status",
    Relations:"Relations",
    LocalCreditScore:"Local Credit Score",
    SolvencyIndex:"Solvency Index",
    ProbabilityofDefault:"Probability of Default",
    RiskIndicator:"Risk Indicator"
},

RatingAnalysis:{
    IndustyAnalysis:"Industy Analysis",
    GeographicAnalysis:"Geographic Analysis",
    CompanyTypeAnalysis:"Company Type Analysis",
    BiusinessScaleAnalysis:"Biusiness Scale Analysis",
    HistoryAnalysis:"History Analysis",
    NormalDistribution:"Normal Distribution",
    SubjectCompany:"Subject Company",
    Probabilityofthesubjectratinginitsindustry:"Probability of the subject rating in its industry",
    Maximum:"Maximum 10%",
    Mean:"Mean",
    Average:"Average",
    Minimum:"Minimum 10%",
    RatingDistribution:"Rating Distribution",
    Revenue:"Revenue",
    Earning:"Earning",
    TotalAssets:"Total Assets",
    Subjectratinginitsindustrybyfinancialindicators:"Subject rating in its industry by financial indicators",
    Best:"Best",
    Worst:"Worst",
    Rankingofsubject:"Ranking of subject's rating in the industry",
    Industy:"Industy",
    Percentilerank:"Percentile rank: % of companies that scored at or below subjects rating",
    Historicaldevelopmentofsubject:"Historical development of subject's rating in its industry",
    IndustryAverage:"Industry Average",
    SubjectRatingChanges:"Subject Rating Changes"
},
CompetitiveAnalysis:{
    MarketPosition:"Market Position",
    Revenus:"Revenus",
    NetEarnings:"Net Earnings",
    NetAssets:"Net Assets",
    TotalAssets:"Total Assets",
    Employees:"Employees",
    Mean:"Mean",
    Average:"Average",
    Maximum:"Maximum (10%)",
    Worst:"Worst (10%)",
    Subjectcompany:"Subject company",
    PerformanceComparison:"Performance Comparison",
    ProfitabilityRatios:"Profitability Ratios",
    Grossmargin:"Gross margin",
    Returnonassets:"Return on assets",
    Returnonequity:"Return on equity",
    OperatingRatios:"Operating Ratios",
    Stockturnover:"Stock turnover",
    Assetsturnover:"Assets turnover",
    Collectionperiod:"Collection period",
    GrowthRatios:"Growth Ratios",
    Totalassetsgrowthrate:"Total assets growth rate",
    Salesgrowthrate:"Sales growth rate",
    Netprofitgrowthrate:"Net profit growth rate",
    StructuralRatios:"Structural Ratios",
    Debtratio:"Debt ratio",
    Quickratio:"Quick ratio",
    Currentratio:"Current ratio"
},
AccountCenterMenu:{
SearchinSettings:"Search in Settings",//在“设置”中搜索
Account:"Account",//账户
MyAccount :"My Account ",//我的账户
ContactInfo:"Contact Info",//联系信息
AccountSecurity:"Account Security",//账户安全
OrganizationalManagement:"Organizational Management",//组织管理
UserGroup:"User Group",//用户组
User:"User",//用户
Role:"Role",//角色
MyDatabase:"My Database",//我的数据库
MyUsage:"My Usage",//我的使用情况
CompaniesViewed:"Companies Viewed",//查看过的公司
ReportsDownloaded:"Reports Downloaded",//下载的报告
ReportUpdatesOrdered:"Report Updates Ordered",//订购的报告更新
BillingandPayment:"Billing and Payment",//账单和付款
BillRecords:"Bill Records",//账单记录
PaymentRecords:"Payment Records",//付款记录
CreditDeductions:"Credit Deductions",//信用扣款
InvoicesDownloaded:"Invoices Downloaded",//下载的发票
UserSettings:"User Settings",//用户设置
Messages:"Messages",//消息
Notifications:"Notifications",//通知
HelpCenter:"Help Center",//帮助中心
FAQ:"FAQ",//常见问题
Privacy:"Privacy",//隐私
Terms:"Terms",//条款
ReportIssues:"Report Issues",//报告问题
UserGuide:"User Guide",//用户指南
AboutCSI:"About CSI"//关于CSI


},
MyAccount:{
Logintime:'Login time',//登录时间
SignOut:'Sign Out',//退出
DeleteAccount:'Delete Account',//删除账户
AccountID:'Account ID',//账户ID
Enteranewaddress:'Enter a new email address',//输入新的电邮
EnterVerificationCode:'Enter Verification Code',//输入验证码
SendverificationCode:'Send verification Code',//发送验证码
Password:'Password',//密码
Originalpassword:'Original password',//原始密码
Newpassword:'New password',//新密码
Confirmnewpassword:'Confirm new password',//确认新密码
AccountOwnership:'Account Ownership',//账户所有权
IndividualAccount:'Individual Account',//个人账户
GroupAccount:'Group Account',//集团账户
Organizationname:'Organization name',//机构名称
CountryRegion:'Country/Region',//国家/地区
Address:'Address',//地址
City:'City',//城市
ZipCode:'Zip Code',//邮政编码
FirstName:'First Name',//名字
LastName:'Last Name',//姓氏
PhoneNumber:'Phone Number',//电话号码
Email:'Email',//更改
Change:'Change',//更改
Save:'Save',//保存
Cancel:'Cancel',//取消
LastLogin:'Last Login',//上次登录
RecentLogin:'Recent Login',//登录尝试次数
AverageLoginTime:'Average Login Time',//平均登录时间
TotalLoginAttempts:'Total Login Attempts',//登录尝试次数

},
ShippingOrderDetails:{
    Date:"Date",
    MasterBillofLading:"Master Bill of Lading",
    Source:"Source",
    BillNo:"Bill No",
    ImporterBuyer:"Importer / Buyer",
    ExporterSeller:"Exporter / Seller",
    Name:"Name",
    Address:"Address",
    Country:"Country",
    Contact:"Contact",
    Email:"Email",
    CargoInfo:"Cargo Info",
    HSCode:"HS Code",
    Quantity:"Quantity",
    WeightUnit:"Weight Unit",
    ProductDescription:"Product Description",
    Amount:"Amount",
    QuantityUnit:"Quantity Unit",
    Weight:"Weight",
    HSDescription:"HS Description",
    Incoterms:"Incoterms",
    ShippingInfo:"Shipping Info",
    Vessel:"Vessel",
    Consignee:"Consignee",
    MeansofTransport:"Means of Transport",
    CountryofOrigin:"Country of Origin",
    Voyage:"Voyage",
    Notifier:"Notifier",
    CountryofDestnation:"Country of Destnation",
    AddressofOrigin:"Address of Origin",
    Shipper:"Shipper",
    AddressofDestnation:"Address of Destnation",
    Container:"Container",
    ContainerID:"Container ID",
    ContainerType:"Container Type",
    ContainerDescDode:"Container Desc Dode",
    ContainerSize:"Container Size"
},
ReportIssues:{
    Whattypeoferrorsyouarereporting:"What type of errors you are reporting?",
    Tellusmoreaboutyourproblems:"Tell us more about your problems.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"Would you like to provide a screenshot or a file regarding your problem?",
    Fillinyourcontactinformation:"Fill in your contact information",
    FirstName:"First Name",
    LastName:"Last Name",
    PhoneNumber:"Phone Number",
    Email:"Email"
},
UserSettings:{
    LanguageandLocation:"Language and Location",
    Language:"Language",
    Selectyourpreferedlanguage:"Select your prefered language",
    Location:"Location",
    Selectyourlocation:"Select your location",
    NotificationSetting:"Notification Setting",
    EmailNotification:"Email Notification",
    ServiceUpdates:"Service Updates",
    CompanyNews:"Company News"
},
ContactInfo:{
    ContactInfo:"Contact Info",
    FirstName:"First Name",
    LastName:"Last Name",
    PhoneNumber:"Phone Number",
    Email:"Email",
    CountryRegion:"Country/Region",
    AddressLine:"Address Line",
    City:"City",
    ZipCode:"Zip Code",
    Alternativecontactperson:"Alternative contact person",
    Setascontactperson:"Set as contact person",
    Edit:"Edit"
},
AccountSecurity:{
    Setupmysecurityquestions:"Set up my security questions",
    Pleasechooseaquestion:"Please choose a question",
    Pleaseentertheanswertothequestion:"Please enter the answer to the question",
    SessionTimeoutAutomaticLogoutSettings:"Session Timeout: Automatic Logout Settings",
   Thesystemwillautomatically:"The system will automatically log you out after a period of inactivity. The default timeout is set to 5 minutes, but you can adjust this duration as needed."
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"Total Number of Companies Searched",
    TotalNumberofCompaniesCollected:"Total Number of Companies Collected",
    TotalNumberofUpdateReportsOrdered:"Total Number of Update Reports Ordered",
    Date:"Date",
    UserName:"User Name",
    CompanyName:"Company Name",
    Status:"Status",
    UsageType:"Usage Type",
    Entercompanyname:"Enter company name",
    Download:"Download"
},
OrganizationalManagement:{
    GroupName:"Group Name",
    ParentGroupName:"Parent Group Name",
    Organization:"Organization",
    GroupID:"Group ID",
    GroupStatus:"Group Status",
    Operation:"Operation",
    NewlyBuilt:"Newly Built",
    UserAccount:"User Account",
    Role:"Role",
    AccountStatus:"Account Status",
    RoleName:"Role Name",
    Position:"Position",
    RoleStatus:"Role Status",
    Valid:"Valid",
    Invalid:"Invalid",
    PermissionSettings:"Permission Settings"
},
BillingandPayment:{
    TotalNumberofOrders:"Total Number of Orders",
    TotalPaymentAmount:"Total Payment Amount",
    TotalDeductionCredits:"Total Deduction Credits",
    Date:"Date",
    UserAccount:"User Account",
    CompanyName:"Company Name",
    OrderNo:"Order No.",
    OrderType:"Order Type",
    OrderStatus:"Order Status",
    Download:"Download",
    PaymentAmount:"Payment Amount",
    Contactus:"Contact us",
    DownloadInvoice:"Download Invoice",
    CreditsDeducted:"Credits Deducted",
    ReportOrderStatus:"Report Order Status",
    CompanyID:"Company ID",
    CountryRegion:"Country/Region",
    AddressLine:"Address Line",
    City:"City",
    ZipCode:"Zip Code",
    FirstName:"First Name",
    LastName:"Last Name",
    PhoneNumber:"Phone Number",
    Email:"Email",
    BankAccountHolderName:"Bank Account Holder Name",
    BeneficiaryBankName:"Beneficiary Bank Name",
    SWIFTCODE:"SWIFT CODE",
    AccountNumber:"Account Number",
    BeneficiaryBankAddress:"Beneficiary Bank Address",
    ABA:"ABA(Routing Number)",
    IBANnumber:"IBAN number"
},
JiuGuoge:{
  Country:'Country',
  Industry:'Industry',
  CoSize:'Co. Size',
  Liquidity:'Liquidity',
  NoofcoinIndustry:'No. of co. in Industry',
  IndustryRating:'Industry Rating',
  Profitability:'Profitability',
  Growth:'Growth',
  FinancialStructurt:'Financial Structurt',
  Repaying:'Repaying',
},
  ...enLocale
}

export default en